import React from "react";
import { useNavigate } from "react-router-dom";

import { formatAmount } from "../../accessories/accessoryMoney";

const blockingReason = (summary) => {
  if (summary.isEmpty) return "Your cart is empty.";
  if (summary.hasOutOfStock) return "Remove the out-of-stock items to continue.";

  return null;
};

const ShieldIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M10 2.5 16 5v5c0 3.4-2.4 6.4-6 7.5-3.6-1.1-6-4.1-6-7.5V5l6-2.5Z" />
    <path d="M7.4 10.2 9.2 12l3.4-3.6" />
  </svg>
);

const TruckIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M2 5.5h9v8H2zM11 8h3.4l2.6 2.8v2.7h-6z" />
    <circle cx="6" cy="15" r="1.6" />
    <circle cx="14" cy="15" r="1.6" />
  </svg>
);

const CartSummaryPanel = ({ summary }) => {
  const navigate = useNavigate();
  const reason = blockingReason(summary);
  const supplierCount = summary.carts.length;

  return (
    <aside className="sy-flow-card">
      <div className="sy-flow-card-head">
        <h2 className="sy-flow-card-title">Order summary</h2>
      </div>

      <div className="sy-flow-card-body">
        <p className="sy-cart-summary-count">
          <span>{`${summary.itemCount} ${summary.itemCount === 1 ? "item" : "items"}`}</span>
          <span>{`${supplierCount} ${supplierCount === 1 ? "supplier" : "suppliers"}`}</span>
        </p>

        <div className="sy-flow-money">
          <span>Subtotal</span>
          <b>{formatAmount(summary.total, summary.currency)}</b>
        </div>

        <div className="sy-flow-money">
          <span>Delivery &amp; fees</span>
          <b>Calculated at checkout</b>
        </div>

        <div className="sy-flow-total">
          <span>Total so far</span>
          <b>{formatAmount(summary.total, summary.currency)}</b>
        </div>

        <button
          type="button"
          className="sy-flow-btn sy-flow-btn-primary sy-flow-block sy-checkout-cta"
          disabled={Boolean(reason)}
          onClick={() => navigate("/checkout")}
        >
          Proceed to checkout
        </button>

        {reason && <p className="sy-flow-note">{reason}</p>}

        <ul className="sy-flow-assurances">
          <li>
            <ShieldIcon />
            Payment is taken only once your order is confirmed
          </li>
          <li>
            <TruckIcon />
            Delivery options and fees are shown at the next step
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default CartSummaryPanel;
